module.exports = __webpack_public_path__ + "static/media/maher.e46d5edc.jpg";